import {
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	Button,
	ModalCloseButton,
} from '@chakra-ui/react';
import queries from '../../utils/query';
import { useMutation } from '@apollo/client';

function onModalClose({ setViewToDelete, onClose }) {
	setViewToDelete({});
	onClose();
}

function deleteView({ viewToDelete, setViewToDelete, viewList, setViewList, removeViewListItem, onClose, userInfo }) {
	removeViewListItem({
		variables: {
			viewId: viewToDelete.viewId,
			userId: userInfo.email,
		},
	}).then(() => {
		const newViewList = viewList.filter((view) => view.viewId != viewToDelete.viewId);
		setViewList(newViewList);
	});
	onModalClose({ setViewToDelete, onClose });
}

const RemoveProjectModal = ({ isOpen, onClose, viewToDelete, setViewToDelete, viewList, setViewList, userInfo }) => {
	const [removeViewListItem, _] = useMutation(queries.DELETE_VIEW_LIST_ITEM);

	return (
		<Modal isOpen={isOpen} onClick={() => onModalClose({ setViewToDelete, onClose })}>
			<ModalOverlay />
			<ModalContent>
				<ModalHeader>Deletar Projeto</ModalHeader>
				<ModalCloseButton />
				<ModalBody>
					Essa é uma ação irreversível
					<br />
					Você tem certeza que deseja excluir{' '}
					{viewToDelete && viewToDelete.viewName ? `o projeto ${viewToDelete.viewName}?` : 'este projeto?'}
				</ModalBody>
				<ModalFooter>
					<Button size={'sm'} variant="outline" mr={3} onClick={() => onModalClose({ setViewToDelete, onClose })}>
						Cancelar
					</Button>
					<Button
						size={'sm'}
						colorScheme="red"
						onClick={() => {
							deleteView({
								viewToDelete,
								viewList,
								setViewList,
								removeViewListItem,
								onClose,
								setViewToDelete,
								userInfo,
							});
						}}
					>
						Deletar
					</Button>
				</ModalFooter>
			</ModalContent>
		</Modal>
	);
};

export default RemoveProjectModal;
